module.exports = __webpack_public_path__ + "img/ferrero.b2dc264a.png";